<div class="container--no-prod" *ngIf="!isProductionEnvironment">
    <i class="icon icon-alert-triangle"></i>
    <p class="text text-hidden-sm">               
      {{ 'labels.nonProductiveEnvironment' | translate}}
    </p>
</div> 